// @core/api/endpoints/task/list_task_numbering_schemes.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTaskNumberingSchemesResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List numbering schemes
 * Returns task numbering schemes, optionally filtered by scope.
 */
export async function ListTaskNumberingSchemes(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTaskNumberingSchemesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/task-numbering-schemes`;
  const requestOptions = options;
  return client.get<ListTaskNumberingSchemesResponse>(requestPath, { ...requestOptions, params });
}
